"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickRoundedIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var TickRoundedIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M15.2928932,8.29289322 C15.6834175,7.90236893 16.3165825,7.90236893 16.7071068,8.29289322 C17.0976311,8.68341751 17.0976311,9.31658249 16.7071068,9.70710678 L11.2071068,15.2071068 C10.8165825,15.5976311 10.1834175,15.5976311 9.79289322,15.2071068 L7.29289322,12.7071068 C6.90236893,12.3165825 6.90236893,11.6834175 7.29289322,11.2928932 C7.68341751,10.9023689 8.31658249,10.9023689 8.70710678,11.2928932 L10.5,13.0857864 L15.2928932,8.29289322 Z" }))); };
exports.TickRoundedIcon = TickRoundedIcon;
